import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { api } from "@/lib/api";
import { queryClient } from "@/lib/query-client";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    try {
      const me = await queryClient.fetchQuery({
        queryKey: ["me"],
        queryFn: () => api.me(),
        staleTime: 5 * 60_000,
      });
      // Superadmin no tiene cuenta — toda navegación fuera de /admin redirige al panel admin.
      if (me.role === "superadmin" && !location.pathname.startsWith("/admin")) {
        throw redirect({ to: "/admin" });
      }
      // Roles scoped (cliente/supervisor) — solo /media/* y /public/*.
      if ((me.role === "cliente" || me.role === "supervisor")
          && !location.pathname.startsWith("/media")
          && location.pathname !== "/login") {
        throw redirect({ to: "/media" });
      }
      // Tenants nuevos sin proyectos ni perfiles → wizard.
      if (
        me.role !== "superadmin"
        && me.needs_onboarding
        && location.pathname !== "/onboarding"
        && typeof window !== "undefined"
        && window.localStorage?.getItem("onboarding_dismissed") !== "1"
      ) {
        throw redirect({ to: "/onboarding" });
      }
      return { me };
    } catch (e) {
      const status = (e as { status?: number })?.status;
      if (status === 401) {
        throw redirect({ to: "/login" });
      }
      throw e;
    }
  },
  component: AppShell,
});
